import { API_BASE_URL } from './index';
import { getToken, getUser } from './auth';
import { use } from 'react';

export const paymentProofsApi = {
  getPaymentProofs: async (filters = {}) => {
    const token = getToken();
    const user = getUser();

    if (!token) {
      throw new Error('No authentication token');
    }
    if (!user?.companyId) {
      throw new Error('Company ID not available');
    }

    // Build query string from filters
    const queryParams = new URLSearchParams();
    if (filters.estado) queryParams.append('estado', filters.estado);
    if (filters.id_cliente) queryParams.append('id_cliente', filters.id_cliente);
    if (filters.id_prestamo) queryParams.append('id_prestamo', filters.id_prestamo);
    if (filters.whatsapp_number) queryParams.append('whatsapp_number', filters.whatsapp_number);
    if (filters.search) queryParams.append('search', filters.search);
    if (filters.fecha_desde) queryParams.append('fecha_desde', filters.fecha_desde);
    if (filters.fecha_hasta) queryParams.append('fecha_hasta', filters.fecha_hasta);

    const queryString = queryParams.toString();
    const url = `${API_BASE_URL}/api/payment-proofs${queryString ? `?${queryString}` : ''}`;

    const response = await fetch(url, {
      headers: {
        'Content-Type': 'application/json',
        'X-Session-Token': token,
        'X-Company-ID': user.companyId,
      },
    });

    if (!response.ok) {
      const error = await response.json().catch(() => ({ error: 'Failed to load payment proofs' }));
      throw new Error(error.error || 'Failed to load payment proofs');
    }

    return response.json();
  },

  getPaymentProof: async (id) => {
    const token = getToken();
    const user = getUser();

    if (!token) {
      throw new Error('No authentication token');
    }
    if (!user?.companyId) {
      throw new Error('Company ID not available');
    }

    const response = await fetch(`${API_BASE_URL}/api/payment-proofs/${id}`, {
      headers: {
        'Content-Type': 'application/json',
        'X-Session-Token': token,
        'X-Company-ID': user.companyId,
      },
    });

    if (!response.ok) {
      const error = await response.json().catch(() => ({ error: 'Failed to load payment proof' }));
      throw new Error(error.error || 'Failed to load payment proof');
    }

    return response.json();
  },

  getPaymentProofImage: async (id) => {
    const token = getToken();
    const user = getUser();

    if (!token) {
      throw new Error('No authentication token');
    }
    if (!user?.companyId) {
      throw new Error('Company ID not available');
    }

    const response = await fetch(`${API_BASE_URL}/api/payment-proofs/${id}/image`, {
      headers: {
        'X-Session-Token': token,
        'X-Company-ID': user.companyId,
      },
    });

    if (!response.ok) {
      const error = await response.json().catch(() => ({ error: 'Failed to load image' }));
      throw new Error(error.error || 'Failed to load image');
    }

    const blob = await response.blob();
    return URL.createObjectURL(blob);
  },

  validatePaymentProof: async (id, data) => {
    const token = getToken();
    const user = getUser();

    if (!token) {
      throw new Error('No authentication token');
    }
    if (!user?.companyId) {
      throw new Error('Company ID not available');
    }

    const response = await fetch(`${API_BASE_URL}/api/payment-proofs/${id}/validate`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'X-Session-Token': token,
        'X-Company-ID': user.companyId,
      },
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      const error = await response.json().catch(() => ({ error: 'Failed to validate payment proof' }));
      throw new Error(error.error || 'Failed to validate payment proof');
    }

    return response.json();
  },

  rejectPaymentProof: async (id, reason) => {
    const token = getToken();
    const user = getUser();

    if (!token) {
      throw new Error('No authentication token');
    }
    if (!user?.companyId) {
      throw new Error('Company ID not available');
    }

    const response = await fetch(`${API_BASE_URL}/api/payment-proofs/${id}/reject`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'X-Session-Token': token,
        'X-Company-ID': user.companyId,
      },
      body: JSON.stringify({ observaciones: reason }),
    });

    if (!response.ok) {
      const error = await response.json().catch(() => ({ error: 'Failed to reject payment proof' }));
      throw new Error(error.error || 'Failed to reject payment proof');
    }

    return response.json();
  },
};

